export default __webpack_public_path__ + "static/media/biotchnology.9c14da5e.png";